export const LEFT_HAND_ROCK = [
  {
    t: [-0.0123, -0.0183, -0.0267],
    r: [0.5149, -0.0845, -0.1158, 0.8452],
    s: [1, 1, 1],
  },
  {
    t: [0.0153, -0.0052, -0.0437],
    r: [0.2665, -0.0899, -0.3721, 0.8846],
    s: [1, 1, 1],
  },
  {
    t: [0.0335, 0.0154, -0.0867],
    r: [0.0177, 0.1842, -0.6731, 0.716],
    s: [1, 1, 1],
  },
  {
    t: [0.0267, 0.0228, -0.1122],
    r: [0.0728, 0.2226, -0.6735, 0.7011],
    s: [1, 1, 1],
  },
  {
    t: [0.019, 0.0341, -0.1386],
    r: [0.0728, 0.2226, -0.6735, 0.7011],
    s: [1, 1, 1],
  },
  {
    t: [0.0067, 0.0029, -0.0406],
    r: [0.475, -0.2118, -0.0726, 0.851],
    s: [1, 1, 1],
  },
  {
    t: [0.0388, 0.061, -0.0749],
    r: [0.5779, -0.1002, -0.0602, 0.8077],
    s: [1, 1, 1],
  },
  {
    t: [0.0481, 0.097, -0.086],
    r: [0.5059, -0.0922, -0.0672, 0.855],
    s: [1, 1, 1],
  },
  {
    t: [0.0529, 0.1158, -0.0964],
    r: [0.4458, -0.0565, -0.053, 0.8918],
    s: [1, 1, 1],
  },
  {
    t: [0.0562, 0.1334, -0.1107],
    r: [0.4458, -0.0565, -0.053, 0.8918],
    s: [1, 1, 1],
  },
  {
    t: [-0.0052, 0.0075, -0.0412],
    r: [0.5055, -0.126, -0.0623, 0.8513],
    s: [1, 1, 1],
  },
  {
    t: [0.0144, 0.0671, -0.0735],
    r: [0.1227, -0.0631, -0.0269, 0.9901],
    s: [1, 1, 1],
  },
  {
    t: [0.0199, 0.0775, -0.1133],
    r: [-0.4479, -0.0687, -0.0876, 0.8871],
    s: [1, 1, 1],
  },
  {
    t: [0.0211, 0.0534, -0.1312],
    r: [-0.6828, -0.0523, -0.1046, 0.7212],
    s: [1, 1, 1],
  },
  {
    t: [0.0192, 0.0294, -0.1316],
    r: [-0.6828, -0.0523, -0.1046, 0.7212],
    s: [1, 1, 1],
  },
  {
    t: [-0.0167, 0.0074, -0.0424],
    r: [0.491, -0.0372, -0.0778, 0.8669],
    s: [1, 1, 1],
  },
  {
    t: [-0.0075, 0.0623, -0.0758],
    r: [0.1717, -0.0904, 0.0273, 0.9806],
    s: [1, 1, 1],
  },
  {
    t: [-0.0007, 0.0753, -0.1121],
    r: [-0.3257, -0.1136, -0.0418, 0.9377],
    s: [1, 1, 1],
  },
  {
    t: [0.005, 0.0561, -0.1361],
    r: [-0.5492, -0.1111, -0.0905, 0.8233],
    s: [1, 1, 1],
  },
  {
    t: [0.0066, 0.0356, -0.1433],
    r: [-0.5492, -0.1111, -0.0905, 0.8233],
    s: [1, 1, 1],
  },
  {
    t: [-0.0273, 0.0051, -0.0431],
    r: [0.4566, 0.0629, -0.0766, 0.8841],
    s: [1, 1, 1],
  },
  {
    t: [-0.0297, 0.0531, -0.0769],
    r: [0.3942, -0.0035, 0.1163, 0.9116],
    s: [1, 1, 1],
  },
  {
    t: [-0.0317, 0.0768, -0.1013],
    r: [0.4582, 0.0006, 0.1099, 0.882],
    s: [1, 1, 1],
  },
  {
    t: [-0.0341, 0.0951, -0.1136],
    r: [0.4085, -0.0179, 0.0535, 0.911],
    s: [1, 1, 1],
  },
  {
    t: [-0.0354, 0.1086, -0.1266],
    r: [0.4085, -0.0179, 0.0535, 0.911],
    s: [1, 1, 1],
  },
] as const;

export const RIGHT_HAND_ROCK = [
  {
    t: [0.0015, -0.0417, -0.0513],
    r: [0.5617, 0.0123, 0.1355, 0.8161],
    s: [1, 1, 1],
  },
  {
    t: [-0.0235, -0.025, -0.07],
    r: [0.2818, 0.0046, 0.4006, 0.8718],
    s: [1, 1, 1],
  },
  {
    t: [-0.0354, -0.0001, -0.1128],
    r: [-0.0257, -0.2764, 0.6652, 0.6931],
    s: [1, 1, 1],
  },
  {
    t: [-0.0238, 0.0089, -0.1359],
    r: [-0.0006, -0.3419, 0.6556, 0.6733],
    s: [1, 1, 1],
  },
  {
    t: [-0.0088, 0.0215, -0.1584],
    r: [-0.0006, -0.3419, 0.6556, 0.6733],
    s: [1, 1, 1],
  },
  {
    t: [-0.015, -0.0179, -0.0645],
    r: [0.5302, 0.1299, 0.1154, 0.8299],
    s: [1, 1, 1],
  },
  {
    t: [-0.0403, 0.0456, -0.0947],
    r: [0.5874, 0.0115, 0.0813, 0.8051],
    s: [1, 1, 1],
  },
  {
    t: [-0.0451, 0.0825, -0.1058],
    r: [0.5048, 0.001, 0.0806, 0.8595],
    s: [1, 1, 1],
  },
  {
    t: [-0.0468, 0.1015, -0.1165],
    r: [0.4494, -0.0352, 0.0601, 0.8906],
    s: [1, 1, 1],
  },
  {
    t: [-0.0465, 0.1195, -0.1308],
    r: [0.4494, -0.0352, 0.0601, 0.8906],
    s: [1, 1, 1],
  },
  {
    t: [-0.0029, -0.0139, -0.063],
    r: [0.5567, 0.046, 0.0996, 0.8234],
    s: [1, 1, 1],
  },
  {
    t: [-0.016, 0.0502, -0.0895],
    r: [0.1657, -0.0189, 0.0053, 0.986],
    s: [1, 1, 1],
  },
  {
    t: [-0.0146, 0.0642, -0.1285],
    r: [-0.4455, 0.0104, 0.0258, 0.8948],
    s: [1, 1, 1],
  },
  {
    t: [-0.0143, 0.0404, -0.1468],
    r: [-0.7027, 0.0133, 0.0292, 0.7107],
    s: [1, 1, 1],
  },
  {
    t: [-0.0137, 0.0163, -0.146],
    r: [-0.7027, 0.0133, 0.0292, 0.7107],
    s: [1, 1, 1],
  },
  {
    t: [0.0087, -0.0144, -0.0627],
    r: [0.5389, -0.0411, 0.1061, 0.8346],
    s: [1, 1, 1],
  },
  {
    t: [0.0058, 0.0446, -0.0897],
    r: [0.2331, 0.0139, -0.0389, 0.9716],
    s: [1, 1, 1],
  },
  {
    t: [0.0052, 0.0621, -0.1248],
    r: [-0.3041, 0.0513, -0.0024, 0.9512],
    s: [1, 1, 1],
  },
  {
    t: [0.0022, 0.0442, -0.1503],
    r: [-0.5472, 0.0609, 0.0335, 0.8341],
    s: [1, 1, 1],
  },
  {
    t: [0.0009, 0.0239, -0.1579],
    r: [-0.5472, 0.0609, 0.0335, 0.8341],
    s: [1, 1, 1],
  },
  {
    t: [0.0194, -0.0172, -0.0627],
    r: [0.5054, -0.1365, 0.0899, 0.8473],
    s: [1, 1, 1],
  },
  {
    t: [0.0276, 0.0346, -0.0893],
    r: [0.4597, -0.0527, -0.1093, 0.8797],
    s: [1, 1, 1],
  },
  {
    t: [0.0334, 0.0611, -0.1099],
    r: [0.5162, -0.056, -0.0989, 0.8489],
    s: [1, 1, 1],
  },
  {
    t: [0.0378, 0.0805, -0.1194],
    r: [0.4448, -0.0407, -0.0462, 0.8935],
    s: [1, 1, 1],
  },
  {
    t: [0.0411, 0.0949, -0.1311],
    r: [0.4448, -0.0407, -0.0462, 0.8935],
    s: [1, 1, 1],
  },
] as const;
